export const newsItems = [
  {
    title: 'New paper out!',
    newsId: "news1",
    date: '17 OCT 2025',
    description:
      'A new paper ’Building immune digital twins: An international and transdisciplinary community effort’ has been released',
    image: '/images/news1.png',
    link: '/news-events/news/news1',
    type: 'internal',
    extLink: '',
    mainContent: `
Digital twins represent a key technology for precision health. Medical digital twins consist of computational models that represent the health state of individual patients over time, enabling optimal therapeutics and forecasting patient prognosis. Many health conditions involve the immune system, so it is crucial to include its key features when designing medical digital twins. The immune response is complex and varies across diseases and patients, and its modelling requires the collective expertise of the clinical, immunology, and computational modelling communities. This review outlines the initial progress on immune digital twins and the various initiatives to facilitate communication between interdisciplinary communities. We also outline the crucial aspects of an immune digital twin design and the prerequisites for its implementation in the clinic. We propose some initial use cases that could serve as “proof of concept” regarding the utility of immune digital technology, focusing on diseases with a very different immune response across spatial and temporal scales (minutes, days, months, years). Lastly, we discuss the use of digital twins in drug discovery and point out emerging challenges that the scientific community needs to collectively overcome to make immune digital twins a reality.

Read the full article on [Nature.com](https://www.nature.com/articles/s41540-024-00450-5).
    `,
  },
  {
    title: 'Medicine Nobel goes to scientists who revealed secrets of immune system regulation',
    newsId: "news2",
    date: '8 OCT 2025',
    description:
      'This year’s Nobel Prize in Physiology or Medicine has been awarded to three scientists for discovering a class of immune cells that help to prevent the body from attacking its own tissues.',
    image: '/images/news2.jpg',
    link: '/news-events/news/news2',
    type: 'internal',
    extLink: '',
    mainContent: `
This year’s Nobel Prize in Physiology or Medicine has been awarded to three scientists for discovering a class of immune cells that help to prevent the body from attacking its own tissues.

**Mary Brunkow**, a molecular biologist at the Institute for Systems Biology in Seattle, Washington; **Fred Ramsdell**, a scientific adviser at the firm Sonoma Biotherapeutics in Seattle, Washington; and immunologist **Shimon Sakaguchi** at the University of Osaka in Suita, Japan, will share the prize of 11 million Swedish krona (US$1 million) *"for their discoveries concerning peripheral immune tolerance."*

---

### How to win a Nobel prize: what kind of scientist scoops medals?

The trio “have provided fundamental knowledge of how the immune system is regulated,” said Nobel committee member **Marie Wahren-Herlenius**, a rheumatologist at the Karolinska Institute in Stockholm, at a press conference announcing the prize. Their discoveries help to explain “how we keep our immune system under control so we can fight all imaginable microbes and still avoid autoimmune disease.”

The findings led to the development of a range of therapies for autoimmune diseases that are now in early clinical development, says **Samantha Bucktrout**, an immunologist at Greywolf Therapeutics in Oxford, UK, who has previously worked with Ramsdell.

> "If it wasn’t for these initial findings — and all of this whole field that these individuals started — we would never be at this place now where we can talk about cures," she says.

Autoimmune conditions — including type 1 diabetes, arthritis and multiple sclerosis — affect around one in ten people.
`,
  },
  {
    title: 'A Tiny Chemistry Hack Just Made mRNA Vaccines Safer, Stronger, and Smarter',
    newsId: "news3",
    date: '25 JUL 2025',
    description:
      'What if mRNA vaccines could be made more powerful and less irritating? Scientists at the University of Pennsylvania have found a way to do just that—by tweaking a key molecule in the vaccine’s delivery system. Using a century-old chemical trick …',
    image: '/images/news3.jpg',
    link: '/news-events/news/news3',
    type: 'external',
    extLink: 'https://www.sciencedaily.com/releases/2025/07/250720034024.htm',
    mainContent: '',
  },
];

export const eventItems = [
  {
    title: 'RDA in Europe Annual Summit',
    eventId: "event1",
    startDate: '18 NOV 2025',
    endDate: '',
    location: 'Paris - France',
    eventType: 'Conference',
    link: '/news-events/events/event1',
    type: 'internal',
    description:
      'This November, RDA Europe and RDA France will collaborate to stage the inaugural RDA in Europe Annual Summit. The European RDA membership is invited to gather, along with key stakeholders. Theme: "Weaving the RDA Tapestry: From Community Insights to Collective Action".',
    image: '/images/event1.png',
    extLink: 'https://www.rd-alliance.org/events/rda-europe-annual-summit/',
    mainContent: `
The **first RDA in Europe Annual Summit** will take place on **18 November 2025** in Paris.  
The event is an RDA Europe initiative, co-organised and hosted by **RDA France** and **CNRS**, and will be co-located with the Annual RDA France meeting on **17 November**.

Taking place at *CNRS, 3 Rue Michel Ange, 75016 Paris, Auditorium Marie-Curie*, the event will provide a dedicated forum for current and prospective European RDA regions and their members to address challenges and solutions at both national and pan-European levels, and discuss RDA’s role and priorities within the broader European landscape.  

It will also offer an opportunity to address key topics relevant to the European RDA community, through the lens of the RDA and to advance its impact across Europe.

---

### Theme: *Weaving the RDA Tapestry: From Community Insights to Collective Action*

The event will deliver a rich programme shaped by RDA European community contributions in the form of lightning talks and posters, as well as a regional roundtable with topics for discussion selected in collaboration with the European RDA regional representatives.  

**Dr. Francoise Genova (RDA France)** will deliver the keynote speech:  
*"RDA France: Liaising with and Supporting the French Plan for Open Science and the RDA."*
    `,
  },
  {
    title: '4th International Conference on Oral Mucosal Immunity and Microbiome (OMIM)',
    eventId: "event2",
    startDate: '12 OCT 2025',
    endDate: '17 OCT 2025',
    location: 'Chania - Crete',
    eventType: 'Conference',
    link: '/news-events/events/event2',
    type: 'internal',
    description:
      'The 4th International Conference on Oral Mucosal Immunity and Microbiome (OMIM) aims to highlight cutting-edge basic and translational research from an oral immunological and microbiological perspective.',
    image: '/images/event2.png',
    extLink: 'https://www.aegeanconferences.org/src/App/conferences/view/191',
    mainContent: `
The **4th International Conference on Oral Mucosal Immunity and Microbiome (OMIM)** aims to highlight cutting-edge basic and translational research from an oral immunological and microbiological perspective.  

Oral diseases with a microbial etiology are the most prevalent chronic diseases of humans. Whilst not life-threatening, they can significantly compromise quality of life, are associated with increased morbidity, and pose heavy financial burdens to national health systems.  

Hence, periodontal and peri-implant diseases, dental caries, root canal infections and mucosal infections are significant global public health problems.  

The microbiome of the oral cavity is the most well characterised of all the microbial populations associated with the human host. However, in order to understand how the composition and functions of the oral microbiome influence the maintenance of health as well as the initiation and progression of oral disease, it is important to now focus on the mechanisms underpinning their interactions with the host — in particular, oral mucosal immunity.

Further progress in this field will be driven by **multi-omic technologies** applied to well defined clinical populations and appropriate model systems, combined with **new computational tools**, imaging technologies and expertise in cellular and molecular biology.  

This 4-day conference provides a focused forum where global experts will summarize and discuss the latest progress made in oral mucosal immunity and the oral microbiome — in an idyllic setting on the island of Crete, near the ancient city of **Knossos**, the birthplace of the first European civilization.  

---

### Publications

- *Frontiers in Oral Health*: Proceedings of the 2nd International Conference on Oral Mucosal Immunity and Microbiome.  
  **Editors:** G.N. Belibasakis and G. Hajishengallis  

- *Frontiers in Oral Health*: Proceedings of the 3rd International Conference on Oral Mucosal Immunity and Microbiome.  
  **Editors:** G.N. Belibasakis and G. Hajishengallis
    `,
  },
];

export const refItems = [    
    {
    title: 'Design specifications for biomedical virtual twins in engineered adoptive cellular immunotherapies',
    refId: "ref1",
    date: '1 AUG 2025',
    description:
      `In (immune)oncology, virtual twins (VTs) offer patient-individual decision support. Nevertheless, current VTs do not incorporate the unique properties of engineered adoptive cellular immunotherapies (eACIs). Here, we outline the minimal design specifications for VTs for engineered ACIs (eACI-VTs) to model the complex interplay between cell product and patient physiology.`,
    image: '/images/ref1.png',
    link: '/resources/references/ref1',
    type: 'external',
    refType: 'educational',
    extLink: 'https://www.nature.com/articles/s41746-025-01809-6',
    mainContent: '',
    },
    {
    title: 'Virtual twins for personalised CAR T-cell therapy in myeloma',
    refId: "ref2",
    date: '6 JUL 2025',
    description:
      `Multiple myeloma is a haematological malignancy characterised by the clonal proliferation of plasma cells in the bone marrow. Despite advances in treatment, multiple myeloma remains incurable, with most patients experiencing multiple relapses.`,
    image: '/images/ref2.png',
    link: '/resources/references/ref2',
    type: 'external',
    refType: 'publication',
    extLink: 'https://doi.org/10.1016/S2352-3026(25)00170-X',
    mainContent: '',
    },
    {
    title: 'Building a modular and multi-cellular virtual twin of the synovial joint in Rheumatoid arthritis',
    refId: "ref3",
    date: '24 DEC 2024',
    description:
      `Rheumatoid arthritis is a complex disease marked by joint pain, stiffness, swelling, and chronic synovitis, arising from the dysregulated interaction between synoviocytes and immune cells. Its unclear etiology makes finding a cure challenging. The concept of digital twins, used in engineering, can be applied to healthcare to improve diagnosis and treatment for complex diseases like rheumatoid arthritis.`,
    image: '/images/ref3.png',
    link: '/resources/references/ref3',
    type: 'external',
    refType: 'publication',
    extLink: 'https://doi.org/10.1038/s41746-024-01396-y',
    mainContent: '',
    },
     {
    title: 'Immune digital twins for complex human pathologies: applications, limitations, and challenges.',
    refId: "ref4",
    date: '30 NOV 2024',
    description:
      `Digital twins represent a key technology for precision health. Medical digital twins consist of computational models that represent the health state of individual patients over time, enabling optimal therapeutics and forecasting patient prognosis`,
    image: '/images/ref4.png',
    link: '/resources/references/ref4',
    type: 'external',
    refType: 'publication',
    extLink: 'https://doi.org/10.1038/s41540-024-00450-5',
    mainContent: '',
    },
    {
    title: 'Forum On Immune Digital Twins: A Meeting Report.',
    refId: "ref5",
    date: '16 FEB 2024',
    description:
      `Digital twins, customized simulation models pioneered in industry, are beginning to be deployed in medicine and healthcare, with some major successes, for instance in cardiovascular diagnostics and in insulin pump control. Personalized computational models are also assisting in applications ranging from drug development to treatment optimization.`,
    image: '/images/ref5.png',
    link: '/resources/references/ref5',
    type: 'external',
    refType: 'reference',
    extLink: 'https://doi.org/10.1038/s41746-022-00610-z',
    mainContent: '',
    },
    {
    title: 'Characterizing the crosstalk between programmed cell death pathways in Cytokine storm with an agent-based model',
    refId: "ref6",
    date: '12 OCT 2023',
    description:
      `There is increasing recognition of extensive crosstalk between programmed cell death pathways (PCDPs), such as apoptosis, pyroptosis, and necroptosis, resulting in a highly redundant system responsive to a breadth of potential pathogens.`,
    image: '/images/ref6.jpg',
    link: '/resources/references/ref6',
    type: 'external',
    refType: 'publication',
    extLink: 'https://doi.org/10.1089/sur.2023.115',
    mainContent: '',
    },

];

export const tutItems = [
    {
    title: 'Twinsanté - RDA-INSERM webinar: Papadopoulou, Niarakis, Reiche',
    tutId: "tut1",
    date: '26 SEP 2025',
    description:
      `Les webinaires du DSI de l'Inserm, les jumeaux numériques pour la santé et la recherche médicale - French`,
    image: '/images/tut1.jpg',
    link: '/resources/videos-tutorials/tut1',
    type: 'external',
    tutType: 'video',
    extLink: 'https://pod.inserm.fr/video/2332-les-webinaires-du-dsi-de-linserm-les-jumeaux-numeriques-pour-la-sante-et-la-recherche-medicalemp4/',
    mainContent: '',
    },
    {
    title: 'NC3R - Non-animal approaches across Europe',
    tutId: "tut2",
    date: '26 FEB 2025',
    description:
      `Prof Anna Niarakis, University of Toulouse III, Paul Sabatier, Center of Integrative Biology, France.
This presentation was given as part of a webinar series from The Togeth3R Consortium of European 3Rs centres, showcasing non-animal approaches in research fields associated with high levels of animal use. In 2023, the immune system was the second highest area of animal use for basic research in the UK and Europe`,
    image: '/images/tut2.png',
    link: '/resources/videos-tutorials/tut2',
    type: 'external',
    tutType: 'video',
    extLink: 'https://vimeo.com/1062053685/6cef4d4d2a?fl=pl&fe=vl',
    mainContent: '',
    },
    {
    title: 'Jumeaux numériques immunitaires',
    tutId: "tut3",
    date: '13 FEB 2025',
    description:
      'Au cours de ce webinaire, Philippe Moingeon, Anna Niarakis, Anne-Sophie Beignon et Vincent Deman présenteront les dernières avancées dans le développement de jumeaux numériques du système immunitaire et la modélisation de sa réponse dans différents contextes biologiques (pathologie, vaccination...)',
    image: '/images/tut3.png',
    link: '/resources/videos-tutorials/tut3',
    type: 'internal',
    tutType: 'video',
    extLink: 'https://www.youtube.com/embed/Kq1b8hRIkqI?start=4',
    mainContent: '',
    },
    {
    title: 'Building Immune Digital Twins - RDA BIDT kick-off meeting',
    tutId: "tut4",
    date: '27 JUN 2024',
    description:
      'Find out more about the Building Immune Digital Twins project through the video of the kick-off meeting with RDA',
    image: '/images/tut4.png',
    link: '/resources/videos-tutorials/tut4',
    type: 'internal',
    tutType: 'video',
    extLink: 'https://www.youtube.com/embed/pTs6zNJ0hpE?start=4',
    mainContent: '',
    },
    {
    title: 'Celldesigner Tutorial',
    tutId: "tut5",
    date: '21 FEB 2024',
    description:
      `Luiz Ladeira introduces Celldesigner, a software to curate and construct molecular interaction models to build physiological maps. Delving into its relevance within the Ontox project, he showcases how these models are crucial for integrating physiological maps, aiding in various aspects of NAMs development for Next Generation Risk Assessment in Toxicology.`,
    image: '/images/tut5.png',
    link: '/resources/videos-tutorials/tut5',
    type: 'external',
    tutType: 'tutorial',
    extLink: 'https://www.youtube.com/embed/c1m5u1Xzkak?start=4',
    mainContent: '',
    },
    {
    title: 'MetaLo package tutorial',
    tutId: "tut6",
    date: '14 JAN 2024',
    description:
      `A short video explaining how to use the MetaLo package to evaluate the impact of Rheumatoid Arthritis by roblast reglatory pathways upon their metabolism`,
    image: '/images/tut6.png',
    link: '/resources/videos-tutorials/tut6',
    type: 'internal',
    tutType: 'tutorial',
    extLink: 'https://gitlab.inria.fr/soliman/metalo/-/raw/main/MetaLo_tutorial.mp4 ',
    mainContent: '',
    },
    {
    title: 'WG Seminars: Laubenbacher and Niarakis, Immune Digital Twins Present and Prospects',
    tutId: "tut7",
    date: '14 JUL 2023',
    description:
      `Report on the Recent 3-week Workshop: 'Building Immune Digital Twins' at  the Institut Pascal, Universite Paris-Saclay
Reinhard Laubenbacher and Anna Niarakis
University of Florida and INRIA`,
    image: '/images/tut7.png',
    link: '/resources/videos-tutorials/tut7',
    type: 'internal',
    tutType: 'video',
    extLink: 'https://www.youtube.com/watch?v=auAnSYvWmss',
    mainContent: '',
    },
    
]

export const modelItems = [
    {
        title: 'Studying HIV latency by modeling the interaction between HIV proteins and the innate immune response.',
        modelId: 'model1',
        date: '14 MAY 2025',
        description: 'Studying HIV latency by modeling the interaction between HIV proteins and the innate immune response.',
        image: '/images/model1.png',
        link: '/models/model1',
        simLink: '/models/sim/model1',
        simImage: '/images/sim1.png',
        extLink: '',
        gitLink: 'https://github.com/ImmuneDT/immunogit/blob/main/models/BioModels/SBML/biomodels_Immune_response/BIOMD0000000573/BIOMD0000000573',
        extSimLink: 'https://biomodels.bacpop.org/view/BIOMD0000000573/plot',
        type: 'internal',
        pubLink: 'http://identifiers.org/pubmed/24997239',
        version: '4',
        fileSize: '588Mb',
        idVal: 'BIOMD0000000573',
        source: 'ImmunoGit',
        foci: [
            {
                focus: 'Immune response'
            }
        ],
        conditions: [
            {
                condition: 'HIV',
            }
        ],
        affiliation: 'Centro de Investigacion y de Estudios Avanzados del IPN, Unidad Monterrey, Vıa del Conocimiento 201, Parque PIIT, CP 66600 Apodaca NL, Mexico; University of Heidelberg, Im Neuenheimer Feld 267, 69120 Heidelberg, Germany.',
        authors:[
            {
                name: 'Aguilera LU',
                orcid: '0000-0003-0609-539X',
            },
            {
                name: 'Jesús Rodríguez-González',
                orcid: '',
            }
        ],
        mainContent: 'HIV infection leads to two cell fates, the viral productive state or viral latency (a reversible non-productive state). HIV latency is relevant because infected active CD4+ T-lymphocytes can reach a resting memory state in which the provirus remains silent for long periods of time. Despite experimental and theoretical efforts, the causal molecular mechanisms responsible for HIV latency are only partially understood. Studies have determined that HIV latency is influenced by the innate immune response carried out by cell restriction factors that inhibit the postintegration steps in the virus replication cycle. In this study, we present a mathematical study that combines deterministic and stochastic approaches to analyze the interactions between HIV proteins and the innate immune response. Using wide ranges of parameter values, we observed the following: (1) a phenomenological description of the viral productive and latent cell phenotypes is obtained by bistable and bimodal dynamics, (2) biochemical noise reduces the probability that an infected cell adopts the latent state, (3) the effects of the innate immune response enhance the HIV latency state, (4) the conditions of the cell before infection affect the latent phenotype, i.e., the existing expression of cell restriction factors propitiates HIV latency, and existing expression of HIV proteins reduces HIV latency.',

    },
    {
        title: 'The re-polarisation of M2 and M1 macrophages and its role on cancer outcomes',
        modelId: 'model2',
        date: '14 MAR 2025',
        description: 'We use a mathematical model for the interactions between mouse melanoma cells, Th2/Th1 cells and M2/M1 macrophages, to investigate the unknown role of the re-polarisation between M1 and M2 macrophages on tumour growth.',
        image: '/images/model2.jpg',
        link: '/models/model2',
        simLink: '/models/sim/model2',
        simImage: '/images/sim2.png',
        extLink: '',
        gitLink: 'https://github.com/ImmuneDT/immunogit/tree/main/models/BioModels/SBML/biomodels_immuno-oncology/BIOMD0000000759',
        extSimLink: 'https://biomodels.bacpop.org/view/BIOMD0000000759/plot',
        type: 'internal',
        pubLink: 'http://identifiers.org/pubmed/26551154',
        version: '5',
        fileSize: '327Mb',
        idVal: 'BIOMD0000000759',
        source: 'ImmunoGit',
        foci: [
            {
                focus: 'Immuno-oncology'
            }
        ],
        conditions: [
            {
                condition: 'Cancer',
            }
        ],
        affiliation: 'Centre for Advanced Computational Solutions (C-fACS), Lincoln University, Lincoln 7476, New Zealand; Division of Mathematics, University of Dundee, Dundee DD1 4HN, United Kingdom; Division of Cancer Research, University of Dundee, Dundee DD1 9SY, United Kingdom.',
        authors:[
            {
                name: 'Nicoline Y den Breems',
                orcid: '0000-0001-7300-4975',
            },
            {
                name: 'Eftimie R',
                orcid: '0000-0002-9726-1498',
            }
        ],
        mainContent: 'The anti-tumour and pro-tumour roles of Th1/Th2 immune cells and M1/M2 macrophages have been documented by numerous experimental studies. However, it is still unknown how these immune cells interact with each other to control tumour dynamics. Here, we use a mathematical model for the interactions between mouse melanoma cells, Th2/Th1 cells and M2/M1 macrophages, to investigate the unknown role of the re-polarisation between M1 and M2 macrophages on tumour growth. The results show that tumour growth is associated with a type-II immune response described by large numbers of Th2 and M2 cells. Moreover, we show that (i) the ratio k of the transition rates k12 (for the re-polarisation M1→M2) and k21 (for the re-polarisation M2→M1) is important in reducing tumour population, and (ii) the particular values of these transition rates control the delay in tumour growth and the final tumour size. We also perform a sensitivity analysis to investigate the effect of various model parameters on changes in the tumour cell population, and confirm that the ratio k alone and the ratio of M2 and M1 macrophage populations at earlier times (e.g., day 7) cannot always predict the final tumour size.',

    },
    {
        title: 'Tumor-immune system interactions and determination of the optimal therapeutic protocol in immunotherapy',
        modelId: 'model3',
        date: '14 MAR 2025',
        description: 'Studying HIV latency by modeling the interaction between HIV proteins and the innate immune response.',
        image: '/images/model3.jpg',
        link: '/models/model3',
        simLink: '/models/sim/model3',
        simImage: '/images/sim3.png',
        extLink: '',
        gitLink: 'https://github.com/ImmuneDT/immunogit/tree/main/models/BioModels/SBML/biomodels_immuno-oncology/BIOMD0000001036',
        extSimLink: 'https://biomodels.bacpop.org/view/BIOMD0000001036/plot',
        type: 'internal',
        pubLink: 'http://identifiers.org/pubmed/17416392',
        version: '9',
        fileSize: '613Mb',
        idVal: 'BIOMD0000001036',
        source: 'ImmunoGit',
        foci: [
            {
                focus: 'Immuno-oncology'
            }
        ],
        conditions: [
            {
                condition: 'Cancer',
            }
        ],
        affiliation: 'Istituto Applicazioni Calcolo - CNR, V.le del Policlinico 137, 00161 Roma, Italy.',
        authors:[
            {
                name: 'Antonio Cappuccio',
                orcid: '0000-0002-8266-2344',
            },
            {
                name: 'Castiglione F',
                orcid: '0000-0002-1442-3552',
            },
            {
                name: 'Benedetto Piccoli',
                orcid: '0000-0002-6000-5394',
            }
        ],
        mainContent: 'Cancer immunotherapy aims at eliciting an immune system response against the tumor. However, it is often characterized by toxic side-effects. Limiting the tumor growth and, concurrently, avoiding the toxicity of a drug, is the problem of protocol design. We formulate this question as an optimization problem and derive an algorithm for its solution. Unlike the standard optimal control approach, the algorithm simulates impulse-like drug administrations. It relies on an exact computation of the gradient of the cost function with respect to any protocol by means of the variational equations, that can be solved in parallel with the system. In comparison with previous versions of this method [F. Castiglione, B. Piccoli, Optimal control in a model of dendritic cell transfection cancer immunotherapy, Bull. Math. Biol. 68 (2006) 255-274; B. Piccoli, F. Castiglione, Optimal vaccine scheduling in cancer immunotherapy, Physica A. 370 (2) (2007) 672-680], we optimize both the timing and the dosage of each administration and introduce a penalty term to avoid clustering of subsequent injections, a requirement consistent with the clinical practice. In addition, we implement the optimization scheme to simulate the case of multi-therapies. The procedure works for any ODE system describing the pharmacokinetics and pharmacodynamics of an arbitrary number of therapeutic agents. In this work, it was tested for a well known model of the tumor-immune system interaction [D. Kirschner, J.C. Panetta, Modeling immunotherapy of tumor-immune interaction, J. Math. Biol. 37 (1998) 235-252]. Exploring three immunotherapeutic scenarios (CTL therapy, IL-2 therapy and combined therapy), we display the stability and efficacy of the optimization method, obtaining protocols that are successful compromises between various clinical requirements.',

    },
    {
        title: 'Paradoxical sex-specific patterns of autoantibody response to SARS-CoV-2 infection',
        modelId: 'model4',
        date: '7 SEP 2024',
        description: 'To examine sex-specific autoimmune reactivity to SARS-CoV-2 in the absence of extreme clinical disease.',
        image: '/images/model4.png',
        link: '/models/model4',
        simLink: '/models/sim/model4',
        simImage: '/images/sim4.png',
        extLink: 'https://doi.org/10.21430/M3DDUQLRWL',
        gitLink: '',
        extSimLink: '',
        type: 'external',
        pubLink: '',
        version: '',
        fileSize: '',
        idVal: 'SDY2600',
        source: 'immport.org',
        foci: [
            {
                focus: 'Autoimmunity'
            }
        ],
        conditions: [
            {
                condition: 'Autoimmune disease',
            },
            {
                condition: 'COVID-19',
            },
            {
                condition: 'Systemic lupus erythematosus',
            }
        ],
        affiliation: 'Cedars-sinai Medical Center',
        authors:[
            {
                name: 'Joseph Ebinger',
                orcid: '',
            },
            {
                name: 'Kimia Sobhani',
                orcid: '',
            },
            {
                name: 'Susan Cheng',
                orcid: '',
            }
            ,
            {
                name: 'Jennifer Van Eyk',
                orcid: '',
            }
            ,
            {
                name: 'Justyna Fert-bober',
                orcid: '',
            }
            ,
            {
                name: 'Jonathan Braun',
                orcid: '',
            }
        ],
        mainContent: 'Background: Pronounced sex differences in the susceptibility and response to SARS-CoV-2 infection remain poorly understood. Emerging evidence has highlighted the potential importance of autoimmune activation in modulating the acute response and recovery trajectories following SARS-CoV-2 exposure. Given that immune-inflammatory activity can be sex-biased in the setting of severe COVID-19 illness, the aim of the study was to examine sex-specific autoimmune reactivity to SARS-CoV-2 in the absence of extreme clinical disease. Methods: In this study, we assessed autoantibody (AAB) reactivity to 91 autoantigens previously linked to a range of classic autoimmune diseases in a cohort of 177 participants (65% women, 35% men, mean age of 35) with confirmed evidence of prior SARS-CoV-2 infection based on presence of antibody to the nucleocapsid protein of SARS-CoV-2. Data were compared to 53 pre-pandemic healthy controls (49% women, 51% men). For each participant, sociodemographic data, serological analyses, SARS-CoV-2 infection status and COVID-19 related symptoms were collected by an electronic survey of questions. The symptoms burden score was constructed based on the total number of reported symptoms (N = 21) experienced within 6 months prior to the blood draw, wherein a greater number of symptoms corresponded to a higher score and assigned as more severe burden. Results: In multivariable analyses, we observed sex-specific patterns of autoreactivity associated with the presence or absence (as well as timing and clustering of symptoms) associated with prior COVID-19 illness. Whereas the overall AAB response was more prominent in women following asymptomatic infection, the breadth and extent of AAB reactivity was more prominent in men following at least mildly symptomatic infection. Notably, the observed reactivity included distinct antigens with molecular homology with SARS-CoV-2. Conclusion: Our results reveal that prior SARS-CoV-2 infection, even in the absence of severe clinical disease, can lead to a broad AAB response that exhibits sex-specific patterns of prevalence and antigen selectivity. Further understanding of the nature of triggered AAB activation among men and women exposed to SARS-CoV-2 will be essential for developing effective interventions against immune-mediated sequelae of COVID-19.',

    },
]